<template>
  <div>
    <table width="100%">
      <thead>
        <tr>
          <th>
            <header h1="Employee Report" :exportToExcel="getExportObject()"></header>
          </th>
        </tr>
        <tr>
          <th class="header">
            <img src="\Images\Image.png" alt="The Universal Insurance Company Limited Logo">
            <div class="header-text">
              <div class="title">The Universal Insurance Company Limited</div>
              <div class="subtitle">Know Your Customer (KYC) / Customer Due Diligence (CDD) Form</div>
              <div class="clientreport">Client Report</div>
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>
            <table border="1" width="100%" style="border-collapse: collapse; font-size: 12px;">
              <tr>
                <td width="8%" class="bg">Client Type</td>
                <td width="25.3%">{{clienttype}}</td>
                <td width="8%" class="bg">Risk Category</td>
                <td width="25.3%">{{riskcategory}}</td>
              </tr>
            </table>


            <table id="tbl2" border="1" width="100%" style="border-collapse:collapse; font-size: 10px; margin-top:10px">
              <thead>
                <tr>
                  <th class="bg" style="width: 5%;">Sr.</th>
                  <th class="bg" style="width: 10%;">Client Type</th>
                  <th class="bg" style="width: 10%; text-align: center;">Low</th>
                  <th class="bg" style="width: 10%; text-align: center;">Medium</th>
                  <th class="bg" style="width: 10%; text-align: center;">High</th>
                </tr>
              </thead>

              <tbody>
                <tr v-for="(item, ind) in clients">
                  <td align="center">{{ ind + 1 }}</td>
                  <td>{{ item.PTR_TYPE }}</td>
                  <td style="text-align: center;">{{ item.LowRisk }}</td>
                  <td style="text-align: center;">{{ item.MediumRisk }}</td>
                  <td style="text-align: center;">{{ item.HighRisk }}</td>
                </tr>
              </tbody>


            </table>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
  const axios = require('axios').default;
  export default ({
    data() {
      return {
        clienttype: '',
        riskcategory: '',
        clients: [],
        loading: true,
      }
    },
    created: function () {
      this.pageLoad();
    },
    methods: {
      pageLoad() {
        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams) {
          var vm = this;
          startReq();
          axios.post('/api/UICApi/loadClientSummary', {
            PTR_ID: Number(urlParams.get('PTR_ID')),
            RiskCategory: Number(urlParams.get('RiskCategory')),
          })
            .then(function (res) {
              endReq();
              vm.clients = res.data.clients;
              vm.clienttype = res.data.clienttype;
              vm.riskcategory = res.data.riskcategory;
              vm.loading = false;
            });
          var uri = window.location.toString();
          if (uri.indexOf("?") > 0) {
            var clean_uri = uri.substring(0, uri.indexOf("?"));
            window.history.replaceState({}, document.title, clean_uri);
          }
        }
      },

      getExportObject() {

        return {
          sheetName: "Client Reprt",
          tables: [
            { tbl: 'tbl2', name: 'Sheet1' },
          ]
        };

      },

    }
  })</script>
<style>
  .bg {
    background-color: lightgrey;
  }

  [data-tag=P] {
    color: green;
  }

  [data-tag=A] {
    color: red;
  }

  [data-tag=L] {
    color: blue;
  }

  [data-tag=H] {
    color: darkblue;
  }

  .header {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
  }

    .header img {
      width: 100px;
      margin-right: 20px;
    }

  .header-text {
    flex: 1;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/ims/ClientSummaryPrint.vue